<script>
import { getCurrentMonthRange, formatDateBR } from "@src/helpers/date";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "DateRangeCalendar",
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        startDate: null,
        endDate: null,
      }),
    },
  },
  data() {
    const monthRange = getCurrentMonthRange();

    return {
      formatDateBR,
      date: {
        startDate: this.value.startDate || monthRange.startDate,
        endDate: this.value.endDate || monthRange.endDate,
      },
      localeDate: {
        direction: "ltr",
        format: "DD/MM/YYYY",
        separator: " - ",
        applyLabel: "Aplicar",
        cancelLabel: "Cancelar",
        weekLabel: "W",
        customRangeLabel: "Intervalo personalizado",
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        monthNames: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        firstDay: 0,
      },
    };
  },
  computed: {
    dateRanges() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);

      let lastWeek = new Date();
      lastWeek.setDate(today.getDate() - 7);
      lastWeek.setHours(0, 0, 0, 0);

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        "Última semana": [lastWeek, today],
        "Este mês": [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth() + 1, 0),
        ],
        "Este ano": [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        "Último mês": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      };
    },
  },
  watch: {
    date: {
      handler(newVal) {
        this.$emit("change", newVal);
      },
      immediate: true,
    },
    value: {
      handler(newVal) {
        this.date = newVal;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <DateRangePicker
    id="range"
    ref="picker"
    opens="right"
    v-model="date"
    class="w-100"
    :locale-data="localeDate"
    :show-week-numbers="false"
    :show-dropdowns="true"
    :linkedCalendars="false"
    :auto-apply="true"
    :ranges="dateRanges"
  >
    <template v-if="date.startDate && date.endDate" v-slot:input="picker">
      {{ formatDateBR(picker.startDate) }} - {{ formatDateBR(picker.endDate) }}
    </template>
    <template v-else v-slot:input> Período </template>
  </DateRangePicker>
</template>

<style scoped lang="scss">
::v-deep {
  .daterangepicker.ltr .drp-calendar.left {
    border: 0;
    padding-left: 0;
  }

  .drp-buttons {
    border: 0 !important;
  }

  .daterangepicker .drp-calendar {
    max-width: 400px;
  }

  .daterangepicker .calendar-table td,
  .daterangepicker .calendar-table th {
    padding: 8px;
  }

  .calendars {
    flex-direction: column;

    .active {
      background: #000c0b !important;
      color: #fff !important;
    }

    .in-range {
      background-color: #f5f5f5;
    }

    ul {
      display: flex;
      justify-content: center;
      gap: 0.5rem;
      width: 100% !important;

      li {
        font-weight: 600;
        color: #000c0b;
        border: 1px solid #e5e7e7;
        border-radius: 8px;
      }
    }
  }

  .calendars-container {
    gap: 0.5rem;
  }

  .daterangepicker {
    width: 650px !important;
    padding: 0.75rem;
    min-width: auto !important;

    &.opensright {
      left: 0px !important;
    }

    .drp-selected {
      color: #000c0b !important;
    }

    .yearselect,
    .monthselect {
      background: #fff;
      text-align: center;
    }

    .applyBtn {
      background: #000c0b !important;
      width: 85px;
      height: 33px;
      border-radius: 8px;
    }

    .cancelBtn {
      background: #fff !important;
      width: 85px;
      height: 33px;
      border-radius: 8px;
      color: #999e9d;
    }
  }
}
</style>
